import Vue from 'vue';
import Vuex from 'vuex';
// import 'es6-promise/auto';
import createPersistedState from "vuex-persistedstate"
// import SecureLS from "secure-ls"
// let ls = new SecureLS({ isCompression: false })

import layout from './modules/layout';
import menu from './modules/menu';
// import chat from './modules/chat';
// import products from './modules/products';
// import email from './modules/email';
// import todo from './modules/todo';
// import firebase_todo from './modules/firebase_todo';
// import jobs from './modules/jobs';
// import courses from './modules/courses';
// import common from './modules/common';
import { alert } from './modules/alert'
import { authentication } from './modules/authentication'
import { users } from './modules/users'

Vue.use(Vuex);

export const store = new Vuex.Store({
    plugins: [createPersistedState()],
    // plugins: [createPersistedState({
    //     storage: {
    //         getItem: (key) => ls.get(key),
    //         setItem: (key, value) => ls.set(key, value),
    //         removeItem: (key) => ls.remove(key),
    //     },
    // })],
    state: {
    },
    mutations: {
        changeLang (state, payload) {
            localStorage.setItem('currentLanguage', payload.id)
            localStorage.setItem('currentLanguageIcon', payload.icon)
            window.location.reload()
        },
        WS_EVENT_NAME() {

        },
    },
    actions: {
      setLang ({ commit }, payload) {
        commit('changeLang', payload)
      },
        WS_EVENT_NAME() {

        },
    },
    modules: {
      alert,
      authentication,
      users,
      layout,
      // chat,
      menu,
      // products,
      // email,
      // todo,
      // firebase_todo,
      // jobs,
      // courses,
      // common
    }
});

